// Only load app.vue if not on the homepage or on the search results page or a gform page

if (window.location.pathname !== "/ltamex/") {
	if (!document.querySelector(".gform_wrapper")&& !document.querySelector(".page-template-template-search-results-php")) {
		require("./app");
	}
}
/*
 * Add JavaScript modules below
 */

import navigation from "./partials/navigation";
import content from "./partials/content";
import heroFade from "./partials/hero-fade";
import formatHeroTagline from "./partials/format-hero-tagline";
import search from "./partials/search";
import controls from "./partials/controls";
import map from "./partials/map";
import relatedItems from "./partials/related-items";
import sideNav from "./partials/side-nav";
import officesMap from "./partials/offices-map";
import video from "./partials/video";
import officeMap from "./partials/googlemaps";
import moreNews from "./partials/more-news";
import reports from "./partials/reports-feed";
import homeModalVideo from "./partials/home-modal-video";

navigation();
content();
heroFade();
formatHeroTagline();
search();
controls();
map();
relatedItems();
sideNav();
officesMap();
video();
officeMap();
moreNews();
homeModalVideo();
//reports();



// WEBPACK FOOTER //
// ./src/js/index.js